export const COMMON_DIALOG_PARENT_SELECTOR = '#common-dialog-wrapper';
